import { render, staticRenderFns } from "./ProcessingAndManagedManagementGeneralInformation.vue?vue&type=template&id=52b6a674&scoped=true&"
import script from "./ProcessingAndManagedManagementGeneralInformation.vue?vue&type=script&lang=ts&"
export * from "./ProcessingAndManagedManagementGeneralInformation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b6a674",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCard,VCol,VFileInput,VForm,VRow,VSelect,VTextField,VTextarea})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\javie\\Documents\\Javier\\Developer\\Landing Dayco\\dayco-cportal-app-client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52b6a674')) {
      api.createRecord('52b6a674', component.options)
    } else {
      api.reload('52b6a674', component.options)
    }
    module.hot.accept("./ProcessingAndManagedManagementGeneralInformation.vue?vue&type=template&id=52b6a674&scoped=true&", function () {
      api.rerender('52b6a674', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tickets/incidents/processing-and-managed-management/components/ProcessingAndManagedManagementGeneralInformation.vue"
export default component.exports